"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localStorageDeleteAllData = ({ callbacks, executeProcesses, processor, }) => {
    processor.root.localStorage.clean();
    executeProcesses(undefined, callbacks.success);
};
exports.default = localStorageDeleteAllData;
